<ng-container>
  <div class="sso-page">
    <div class="unauthorized-error">
      <div class="container">
        <div class="unauth-img"></div>
        <h1>{{ 'pagenot.pagedoes' | cxTranslate }}</h1>
        <p>
          {{ 'pagenot.thepageur' | cxTranslate }}
          <br />
          {{ 'pagenot.returnyour' | cxTranslate }}
          <a (click)="redirectToHomepage()">{{
            'pagenot.homepage' | cxTranslate
          }}</a
          >.
        </p>
      </div>
    </div>
  </div>
</ng-container>
